var $ = require('jquery');
var page = require('../../components/page');
var uniform = require('../../components/uniform');

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts($flyInDialog) {
    var o = {
        bonusproducts: []
    };
    var bonusproducts = o.bonusproducts;
    $flyInDialog.find('.bonusproduct-flyin-form .bonus-product').each(function () {
        var $bonusProduct = $(this);
        var bonusProductData = $bonusProduct.data('bonusproduct');
        if ($bonusProduct.find('.bonus-product-radio, .bonus-product-checkbox').is(':checked')) {
            bonusproducts.push({
                product: {
                    pid: bonusProductData.pid,
                    qty: 1,
                    options: {}
                }
            });
        }
    });
    return o;
}

module.exports = function ($flyInDialog) {
    uniform();
    $flyInDialog
        .find('.bonus-product-flyin')
        .on('submit', 'form.bonusproduct-flyin-form', function (ev) {
            ev.preventDefault();
            $.ajax({
                type: 'POST',
                dataType: 'json',
                cache: false,
                contentType: 'application/json',
                url: this.action,
                data: JSON.stringify(getBonusProducts($flyInDialog))
            }).done(function () {
                page.refresh();
            });
        })
        .on('change', '.bonus-product-radio', function () {
            $flyInDialog.find('.add-bonus-to-cart-button').removeAttr('disabled');
        })
        .on('change', '.bonus-product-checkbox', function () {
            var $uncheckedBonusItems = $('.bonus-product-checkbox:not(:checked)');
            var checkedBonusItemCount = $('.bonus-product-checkbox:checked').length;
            var notChosenCount = $('.cart-freebie-notchoosen').data('max-items');
            var disabledText = $('.cart-freebie-notchoosen').data('disabled-text');

            if (checkedBonusItemCount) {
                $flyInDialog.find('.add-bonus-to-cart-button').removeAttr('disabled');

                if (checkedBonusItemCount >= notChosenCount) {
                    $uncheckedBonusItems.prop('disabled', true);
                    $uncheckedBonusItems.prop('title', disabledText);
                } else {
                    $uncheckedBonusItems.prop('disabled', false);
                    $uncheckedBonusItems.prop('title', '');
                }
            } else {
                $flyInDialog.find('.add-bonus-to-cart-button').attr('disabled', 'disabled');
                $uncheckedBonusItems.prop('disabled', false);
                $('li.bonus-product').removeClass('disabled');
                $uncheckedBonusItems.prop('title', '');
            }

            $('li.bonus-product').each(function () {
                var $currentItem = $(this);

                if ($currentItem.find('.bonus-product-checkbox:not(:checked)').length) {
                    $currentItem.removeClass('selected');
                    $currentItem.addClass('non-selected');
                } else if ($currentItem.find('.bonus-product-checkbox:checked').length) {
                    $currentItem.removeClass('non-selected');
                    $currentItem.addClass('selected');
                }

                if (checkedBonusItemCount && checkedBonusItemCount >= notChosenCount) {
                    if ($currentItem.find('.bonus-product-checkbox:not(:checked)').length) {
                        $currentItem.addClass('disabled');
                    } else if ($currentItem.find('.bonus-product-checkbox:checked').length) {
                        $currentItem.removeClass('disabled');
                    }
                } else {
                    $currentItem.removeClass('disabled');
                }
            });
        });
};
